<div class="dialog">
  <img class="big-icon" src="/assets/picflow-icon-52.svg" alt="" />
  <h1>Your First Gallery</h1>
  <p>Please check your workspace name and link before sharing your first gallery.</p>
  <app-create-tenant-form
    [tenant]="activeTenant()"
    [hideCta]="true"
    (onDone)="confirmWorkSpace($event)"
    [initialValue]="initialValue()"
    [noMaxWidth]="true"
  >
    <div class="cta-area">
      <div class="standard-text">
        You can update this later at any time in your
        <a [routerLink]="'/a/settings/workspace'" class="primary-link">Workspace Settings</a>.
      </div>
      <button
        appButton
        name="confirm"
        location="workspace-dialog"
        color="primary"
        shape="round"
        height="4"
        spacing="3"
        size="3"
      >
        <span [class.hidden-text]="loading()">Continue</span>
        @if (loading()) {
          <app-loading-indicator color="white" size="small" class="button-loading-indicator"> </app-loading-indicator>
        }
      </button>
    </div>
  </app-create-tenant-form>
</div>
